import { db } from "common/config/Firebase"

const invoicesCollection = db.collection('invoices')

const findInvoicesUseCase = callback => {
    return invoicesCollection.onSnapshot(callback)
}

export default findInvoicesUseCase
